import { FC } from "react";

import type { AnchorEvent } from "@tsmono/inspect-common/types";

import { EventRow } from "./event/EventRow";
import { EventNode } from "./types";

interface AnchorEventViewProps {
  eventNode: EventNode<AnchorEvent>;
  className?: string;
}

export const AnchorEventView: FC<AnchorEventViewProps> = ({
  eventNode,
  className,
}) => {
  const event = eventNode.event;
  return (
    <EventRow
      eventNodeId={eventNode.id}
      title="Anchor"
      icon="fork"
      className={className}
    >
      <code className="text-style-secondary">{event.anchor_id}</code>
      {event.source ? (
        <span className="text-style-secondary"> · {event.source}</span>
      ) : null}
    </EventRow>
  );
};
